module.exports = __webpack_public_path__ + "static/media/about-bg.b3a0b71c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-bg.jpg
// module id = 363
// module chunks = 33